import React, { type ReactNode } from 'react'

export const EmptyState: React.FC<{ 
    icon?: ReactNode; 
    title: string; 
    desc?: string;
    action?: ReactNode;
}> = ({ icon, title, desc, action }) => (
    <div className="flex flex-col items-center justify-center py-10 px-5 text-center gap-2">
        {icon && (
            <div className="w-11 h-11 rounded-xl bg-gray-100 dark:bg-white/5 border border-black/[.06] dark:border-white/[.06] flex items-center justify-center text-gray-400 mb-1">
                {icon}
            </div>
        )}
        <p className="text-[14px] font-[500] text-gray-700 dark:text-gray-300">{title}</p>
        {desc && <p className="text-[12px] text-gray-400 dark:text-gray-500 max-w-[280px] leading-relaxed">{desc}</p>}
        {action && <div className="mt-2">{action}</div>}
    </div>
)